export default __webpack_public_path__ + "static/taskdefinition11-1677935390703db6fec8b63e3a8cf9e6.png";